import { DateTime } from 'luxon';

/**
 * The version of a policy document: its "Last updated" date as `yyyy-MM-dd`, read from
 * the markdown (`**Last updated:** October 9, 2026`). Sent with a host application so the
 * server records which Host Agreement was accepted. Null when the document has no date.
 */
export function policyVersionOf(markdown: string): string | null {
  const match =
    /\*\*Last (?:updated|revised):?\*\*:?\s*([A-Za-z]+ \d{1,2}(?:st|nd|rd|th)?,? \d{4})/i.exec(
      markdown,
    );
  if (!match) return null;
  const text = match[1].replace(/(\d)(st|nd|rd|th)/i, '$1').replace(/,? (\d{4})$/, ', $1');
  const date = DateTime.fromFormat(text, 'MMMM d, yyyy', { locale: 'en-US' });
  return date.isValid ? date.toISODate() : null;
}
